<template>
  <div class="row px-0">
    <div class="col-md-4">
      <div class="card">
        <div :class="`card-body rounded-lg bg-warning`">
          <div class="media">
            <div class="media-body overflow-hidden">
              <p class="text-truncate text-white font-size-14 mb-2">
                تعداد کل ارورها
              </p>
              <h4 class="text-white mb-0">{{ totalErrors }}</h4>
            </div>
            <div class="text-white">
              <i class="font-size-24 ri-bug-line"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card">
        <div :class="`card-body rounded-lg bg-success`">
          <div class="media">
            <div class="media-body overflow-hidden">
              <p class="text-truncate text-white font-size-14 mb-2">
                تعداد کاربران درگیر ارور
              </p>
              <h4 class="text-white mb-0">{{ totalUserErrors }}</h4>
            </div>
            <div class="text-white">
              <i class="font-size-24 ri-user-line"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card">
        <div :class="`card-body rounded-lg bg-success`">
          <div class="media">
            <div class="media-body overflow-hidden">
              <p class="text-truncate text-white font-size-14 mb-2">
                تعداد ارورهای مشترک ارور
              </p>
              <h4 class="text-white mb-0">{{ totalErrorTypes }}</h4>
            </div>
            <div class="text-white">
              <i class="font-size-24 ri-bug-2-line"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    applicationId: {
      type: [String, Number],
      required: true,
    },
    errorText: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      totalErrors: 0,
      totalUserErrors: 0,
      totalErrorTypes: 0,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      let route = `applications/${this.applicationId}/logs/total-data`;
      if (this.errorText) {
        route = `applications/${this.applicationId}/logs/${this.errorText}/total-data`;
      }
      this.$axios.get(route).then((res) => {
        this.totalUserErrors = res.data.total_users;
        this.totalErrorTypes = res.data.error_types;
        this.totalErrors = res.data.total_errors;
      });
    },
  },
};
</script>
